import { Title } from '@solidjs/meta'
import type { Component } from 'solid-js'
import Card from '~/components/Card'
import Container from '~/components/Container'
import Footer from '~/components/Footer'
import Icon from '~/components/Icon'

const FooterPage: Component = () => {
  return (
    <>
      <Title>Footer - Florez Jaramillo Solutions</Title>

      <Container class="py-8">
        <div class="mb-10 mt-6 text-balance">
          <h1 class="text-4xl font-bold text-foreground mb-4">Footer</h1>
          <p class="text-foreground-subtle text-xl max-w-3xl leading-relaxed">
            Pie de página corporativo configurable: información de empresa, secciones de enlaces, redes sociales, datos de contacto y formulario de newsletter, todo desde props.
          </p>
        </div>

        <div class="space-y-12">
          {/* Por defecto */}
          <Card>
            <Card.Header
              title="Configuración por defecto"
              subtitle="Footer completo con valores predeterminados listos para usar."
              icon={<Icon icon="material-symbols-light:view-carousel-outline" class="text-primary" size={24} />}
            />
            <Card.Body class="p-0">
              <div class="overflow-hidden rounded-b-2xl">
                <Footer onNewsletterSubmit={email => alert(`Suscrito: ${email}`)} />
              </div>
            </Card.Body>
          </Card>

          {/* Personalizado */}
          <Card>
            <Card.Header
              title="Personalizado"
              subtitle="Secciones, redes y contacto definidos por props; newsletter desactivado."
              icon={<Icon icon="material-symbols-light:widgets-outline" class="text-info" size={24} />}
            />
            <Card.Body class="p-0">
              <div class="overflow-hidden rounded-b-2xl">
                <Footer
                  companyName="Acme Studio"
                  companyDescription="Diseño de producto y desarrollo a medida para startups."
                  showNewsletter={false}
                  sections={[
                    {
                      title: 'Producto',
                      links: [
                        { label: 'Características', href: '#' },
                        { label: 'Precios', href: '#' },
                        { label: 'Changelog', href: '#' }
                      ]
                    },
                    {
                      title: 'Legal',
                      links: [
                        { label: 'Privacidad', href: '#' },
                        { label: 'Términos', href: '#' }
                      ]
                    }
                  ]}
                  socialLinks={[
                    { platform: 'GitHub', href: '#', icon: 'material-symbols-light:code' },
                    { platform: 'LinkedIn', href: '#', icon: 'material-symbols-light:share-outline' }
                  ]}
                  contactInfo={{ email: 'hola@acme.studio', address: 'Medellín, Colombia' }}
                  copyrightText="© 2026 Acme Studio. Hecho con cariño."
                />
              </div>
            </Card.Body>
          </Card>

          {/* API Reference */}
          <Card>
            <Card.Header title="API Reference" subtitle="Propiedades principales del componente Footer." icon={<Icon icon="material-symbols-light:code" class="text-foreground-subtle" size={24} />} />
            <Card.Body>
              <div class="overflow-x-auto rounded-xl border border-border">
                <table class="w-full text-sm text-left">
                  <thead class="text-xs uppercase bg-surface-muted text-foreground-subtle">
                    <tr>
                      <th class="px-6 py-4 border-b border-border">Propiedad</th>
                      <th class="px-6 py-4 border-b border-border">Tipo</th>
                      <th class="px-6 py-4 border-b border-border">Descripción</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-border">
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold text-primary">companyName / companyDescription</td>
                      <td class="px-6 py-4 italic text-xs">string</td>
                      <td class="px-6 py-4 italic">Marca y descripción de la columna principal.</td>
                    </tr>
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold">sections</td>
                      <td class="px-6 py-4 italic text-xs">{'{ title, links[] }[]'}</td>
                      <td class="px-6 py-4">Columnas de enlaces de navegación.</td>
                    </tr>
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold text-primary">socialLinks</td>
                      <td class="px-6 py-4 italic text-xs">{'{ platform, href, icon }[]'}</td>
                      <td class="px-6 py-4 italic">Iconos de redes sociales.</td>
                    </tr>
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold">contactInfo</td>
                      <td class="px-6 py-4 italic text-xs">{'{ email?, phone?, address? }'}</td>
                      <td class="px-6 py-4">Datos de contacto.</td>
                    </tr>
                    <tr>
                      <td class="px-6 py-4 font-mono font-bold text-primary">showNewsletter / onNewsletterSubmit</td>
                      <td class="px-6 py-4 italic text-xs">boolean / (email) =&gt; void</td>
                      <td class="px-6 py-4 italic">Formulario de suscripción y su callback.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </>
  )
}

export default FooterPage
